export enum AssigneType {
  event = 'event',
  template = 'template',
  favoriteSections = 'favoriteSections',
}
